export const GET_VIDEO = 'GET_VIDEO'